"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Paper = _interopRequireDefault(require("@material-ui/core/Paper"));

var _styles = require("@material-ui/core/styles");

var _useMediaQuery = _interopRequireDefault(require("@material-ui/core/useMediaQuery"));

var _useBaseProductFilter = _interopRequireDefault(require("../../../products/useBaseProductFilter"));

var _useShoppingCurrency = _interopRequireDefault(require("../../../shop/useShoppingCurrency"));

var _ProductListItemCard = _interopRequireDefault(require("../../../components/ProductListItemCard"));

var _useProductsServiceCallListTransformed = _interopRequireDefault(require("../../../products/useProductsServiceCallListTransformed"));

var _useFilterBuilder = _interopRequireDefault(require("../../../filter/useFilterBuilder"));

var _useProductListFilters = _interopRequireDefault(require("../../../filter/useProductListFilters"));

var _AppLoaderFullscreen = _interopRequireDefault(require("../../../layout/AppLoaderFullscreen"));

var _useShoppingStockOrderingGroup = _interopRequireDefault(require("../../../shop/useShoppingStockOrderingGroup"));

var _ProductList = _interopRequireDefault(require("./ProductList"));

var _CatalogueProductListMultipleFilter = _interopRequireDefault(require("./CatalogueProductListMultipleFilter"));

var _CatalogueProductListPagination = _interopRequireDefault(require("./CatalogueProductListPagination"));

var _betweenNumbersToQueryIncl = _interopRequireDefault(require("./betweenNumbersToQueryIncl"));

var _useProductListOrderMap = _interopRequireDefault(require("./useProductListOrderMap"));

var _useProductListState2 = _interopRequireDefault(require("./useProductListState"));

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      backgroundColor: theme.palette.background.default,
      marginTop: theme.spacing(4)
    }
  };
}, {
  name: 'CatalogueProductList'
});

var paramToQuery = function paramToQuery(p, v) {
  return v && v.length ? {
    _parameters: {
      $elemMatch: {
        code: p,
        value: {
          $in: v
        }
      }
    }
  } : null;
};

var paramsToQuery = function paramsToQuery(params) {
  return Object.values(params).filter(Boolean).length > 0 ? {
    $and: Object.keys(params).map(function (key) {
      return paramToQuery(key, params[key]);
    }).filter(Boolean)
  } : null;
};

var filterMap = {
  price: 'price',
  searchText: 'searchText',
  parameters: 'parameters'
};

function CatalogueProductList(_ref) {
  var pClasses = _ref.classes,
      taxonomyCode = _ref.taxonomyCode;
  var theme = (0, _styles.useTheme)();
  var mobile = (0, _useMediaQuery.default)(theme.breakpoints.down('sm'));
  var filterFields = (0, _useProductListFilters.default)(taxonomyCode);
  var currency = (0, _useShoppingCurrency.default)();
  var stockOrderingGroup = (0, _useShoppingStockOrderingGroup.default)();
  var classes = useStyles({
    classes: pClasses
  });
  var baseFilter = (0, _useBaseProductFilter.default)(true);

  var listRef = _react.default.useRef();

  var filterPrototype = _react.default.useMemo(function () {
    return [{
      field: 'price',
      operator: 'contains',
      value: undefined,
      toQuery: function toQuery(v) {
        return (0, _betweenNumbersToQueryIncl.default)("_pricing._default.priceWithTax.".concat(currency), v);
      }
    }, {
      field: 'parameters',
      operator: 'contains',
      value: undefined,
      toQuery: function toQuery(v) {
        return paramsToQuery(v);
      }
    }];
  }, [currency]);

  var buildFilterBase = (0, _useFilterBuilder.default)(filterMap, filterPrototype);
  var buildFilter = (0, _react.useCallback)(function (parentFilter, filter) {
    var r = buildFilterBase(parentFilter, filter);
    return r.some(function (f) {
      return f.field === 'price' && f.value;
    }) ? r : [].concat((0, _toConsumableArray2.default)(r.filter(function (f) {
      return f.field !== 'price';
    })), [{
      field: 'price',
      operator: 'contains',
      value: undefined,
      toQuery: function toQuery() {
        return (0, _defineProperty2.default)({}, "_pricing._default.priceWithTax.".concat(currency), {
          $exists: true,
          $gt: 0
        });
      }
    }]);
  }, [buildFilterBase, currency]);

  var _useProductListState = (0, _useProductListState2.default)(taxonomyCode, listRef),
      filter = _useProductListState.filter,
      handleChangeFilter = _useProductListState.handleChangeFilter,
      handleChangeOrder = _useProductListState.handleChangeOrder,
      handleChangePage = _useProductListState.handleChangePage,
      handleChangeRowsPerPage = _useProductListState.handleChangeRowsPerPage,
      handleChangeStockOnly = _useProductListState.handleChangeStockOnly,
      handleResetFilter = _useProductListState.handleResetFilter,
      order = _useProductListState.order,
      pagination = _useProductListState.pagination,
      stockOnly = _useProductListState.stockOnly;

  var parentFilter = _react.default.useMemo(function () {
    return [{
      field: '_base',
      toQuery: function toQuery() {
        return baseFilter([taxonomyCode]);
      }
    }, {
      field: '_stock',
      toQuery: function toQuery() {
        return stockOnly ? (0, _defineProperty2.default)({}, "_ordering.".concat(stockOrderingGroup), {
          $lt: 'z'
        }) : (0, _defineProperty2.default)({}, "_ordering.".concat(stockOrderingGroup), {
          $exists: true
        });
      }
    }, {
      field: 'price',
      value: undefined,
      toQuery: function toQuery(v) {
        return (0, _betweenNumbersToQueryIncl.default)("_pricing._default.priceWithTax.".concat(currency), v);
      }
    }];
  }, [baseFilter, currency, stockOnly, stockOrderingGroup, taxonomyCode]);

  var finalFilter = _react.default.useMemo(function () {
    return buildFilter(parentFilter, filter);
  }, [buildFilter, filter, parentFilter]);

  var productListOrderMap = (0, _useProductListOrderMap.default)();

  var _useProductsServiceCa = (0, _useProductsServiceCallListTransformed.default)({
    method: 'post'
  }, currency, finalFilter, productListOrderMap[order], pagination),
      _useProductsServiceCa2 = (0, _slicedToArray2.default)(_useProductsServiceCa, 4),
      result = _useProductsServiceCa2[0],
      error = _useProductsServiceCa2[1],
      loading = _useProductsServiceCa2[2],
      apiCall = _useProductsServiceCa2[3];

  _react.default.useEffect(function () {
    apiCall(finalFilter, productListOrderMap[order], pagination);
  }, [apiCall, finalFilter, order, pagination, productListOrderMap]);

  if (error) throw error;

  var HeaderComponent = function HeaderComponent() {
    return null;
  };

  return /*#__PURE__*/_react.default.createElement(_Paper.default, {
    elevation: mobile ? 0 : 2,
    className: classes.root,
    style: {
      flexGrow: 1
    }
  }, /*#__PURE__*/_react.default.createElement(_AppLoaderFullscreen.default, {
    loading: loading
  }), /*#__PURE__*/_react.default.createElement(_CatalogueProductListMultipleFilter.default, {
    buildFilter: buildFilter,
    currency: currency,
    filter: filter,
    filterHash: taxonomyCode,
    onChange: handleChangeFilter,
    resetFilter: handleResetFilter,
    parentFilter: parentFilter,
    total: result.total,
    filterFields: filterFields,
    handleChangeOrder: handleChangeOrder,
    onChangeRowsPerPage: handleChangeRowsPerPage,
    onChangeStockOnly: handleChangeStockOnly,
    stockOnly: stockOnly,
    rowsPerPage: result.pageSize,
    order: order
  }), /*#__PURE__*/_react.default.createElement(_ProductList.default, {
    ref: listRef,
    data: result.rows,
    availableVariants: [{
      variant: 'cards',
      ItemComponent: _ProductListItemCard.default
    }],
    currency: currency,
    initialVariant: "cards",
    totalItems: result.total,
    HeaderComponent: HeaderComponent,
    PagerComponent: _CatalogueProductListPagination.default,
    pagination: {
      count: result.total,
      onChangePage: handleChangePage,
      onChangeRowsPerPage: handleChangeRowsPerPage,
      page: result.page,
      rowsPerPage: result.pageSize,
      rowsPerPageOptions: [12, 24, 48, 96]
    }
  }));
}

process.env.NODE_ENV !== "production" ? CatalogueProductList.propTypes = {
  classes: _propTypes.default.shape({
    root: _propTypes.default.string
  }),
  taxonomyCode: _propTypes.default.string
} : void 0;
CatalogueProductList.defaultProps = {
  classes: undefined,
  taxonomyCode: undefined
};
var _default = CatalogueProductList;
exports.default = _default;